module.exports = __webpack_public_path__ + "static/ose_logo_white-4ccbc1933e4740bbcd59b840c34209cb.png";